import { render } from "./DevoirDeConseil.vue?vue&type=template&id=0038826a&scoped=true"
import script from "./DevoirDeConseil.vue?vue&type=script&lang=js"
export * from "./DevoirDeConseil.vue?vue&type=script&lang=js"

import "./DevoirDeConseil.vue?vue&type=style&index=0&id=0038826a&scoped=true&lang=css"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0038826a"]])

export default __exports__